export default [
                {"date":1642167315152,"row":8,"col":6,"squares":[[3,2,"#980000"],[4,2,"#980000"],[5,2,"#980000"],[6,2,"#980000"],[7,2,"#980000"],[4,3,"#980000"],[5,3,"#980000"],[6,3,"#980000"],[5,4,"#980000"]]}
            ]